// Глобальная конфигурация фронтенда
// Значения берутся из переменных окружения CRA (начинаются с REACT_APP_)
// .env.example лежит в корне frontend

// Определяем, находимся ли мы в среде Netlify
const isNetlify = Boolean(process.env.REACT_APP_NETLIFY || window.location.hostname.includes('netlify.app'));

// Используем разные базовые URL в зависимости от среды
export const API_BASE_URL = process.env.REACT_APP_API_URL || 
  (isNetlify ? '/.netlify/functions' : 'http://localhost:8000/api');

// Флаг использования мок-данных (демо) в админ-панели
export const USE_MOCK = process.env.REACT_APP_API_USE_MOCK === 'true';

// Для совместимости с нашей админ-панелью
export const API_URL = API_BASE_URL;
